// This page is linked to the email auth link

import Layout from '../components/Layout';
import AuthCard from '../components/AuthCard';

export default function PageAuth() {
  return (
    <Layout screenSized className='page-auth'>
      <AuthCard />
    </Layout>
  );
}
